import React from 'react';

const SvgCa = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="CA_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="CA_svg__b" fill="#fff">
        <use xlinkHref="#CA_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        fill="#FF3131"
        mask="url(#CA_svg__b)"
        d="M20 0h8v20h-8zM0 0h8v20H0zM15.566 9.768c-.129.128-.204.089-.166-.1l.6-3.001-1.333.666-.667-2-.667 2L12 6.667l.6 3.001c.037.183-.038.227-.166.1l-.868-.87a.331.331 0 0 0-.473.01l-.426.425-1.334-.666L10 10l-.426.426a.337.337 0 0 0-.011.47l1.77 1.77h2l.334 2h.666l.334-2h2l1.77-1.77a.33.33 0 0 0-.011-.47L18 10l.667-1.333-1.334.666-.426-.426a.335.335 0 0 0-.473-.008l-.868.869z"
      />
    </g>
  </svg>
);

export default SvgCa;
